<template>
<layout-content>
  <template #toolbar>
    <el-date-picker
      v-model="query.beginTime"
      :picker-options="startDatePickerOptions"
      :clearable="false"
      :editable="false"
      placeholder="开始时间"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd 00:00:00"
      size="small"
      style="width:170px;"
      @change="onBeginTimeChanged"
    />
    <span style="font-size:.7em;color:#606266"> ～ </span>
    <el-date-picker
      v-model="query.endTime"
      :picker-options="endDatePickerOptions"
      :clearable="false"
      :editable="false"
      placeholder="结束时间"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd 23:59:59"
      size="small"
      style="width:170px;"
      @change="onEndTimeChanged"
    />

    <compare-time-year :filter-years="[new Date(query.beginTime).getFullYear()]" @on-years-changed="onYearsChanged" />

    <el-popover
      placement="bottom"
      trigger="click"
    >
      <template>
        <div
          v-for="site in filterSites"
          :key="site.id"
          class="site-selector"
        >
          <el-checkbox v-model="query.siteIds" :label="site.id">{{site.name}}</el-checkbox>
        </div>
      </template>
      <template #reference>
        <el-button size="small">选择站房</el-button>
      </template>
    </el-popover>

    <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <section style="height:400px">
      <aqi-grade ref="chart" @click="onGradeChartClick" />
    </section>
    <section>
      <section
        v-for="data in dataList"
        :key="data.siteId"
        style="font-size:0;float:left;width:33%;height:350px;"
      >
        <v-o-cs-a-q-i-pie-chart
          ref="pie-charts"
          :unit="unit"
          :data="data"
        />
      </section>
    </section>
  </template>
</layout-content>
</template>

<script>
import BaseData from '../../../BaseData'
import AqiGrade from './AqiGrade'
import VOCsAQIPieChart from './VOCsAQIPieChart'

export default {
  name: 'StatisticalAnalysisVOCsAQI',
  routeInfo: {
    label: 'VOCs优良统计',
    icon: 'fa fa-users'
  },
  extends: BaseData,
  components: {VOCsAQIPieChart, AqiGrade},
  data () {
    let date = new Date()
    return {
      query: {
        beginTime: date.format('YYYY/01/01 00:00:00'),
        endTime: date.format('YYYY/12/31 23:59:59'),
        siteIds: [],
        years: [],
        isMultipleIntegral: true,
        isAuditCompleted: false // finished
      },
      unit: 'ppb',
      dataList: []
    }
  },
  computed: {
    siteDeviceCategory: () => process.env.ALL_VOCS_DEVICE_CATEGORY,
    filterSites () {
      return this.sites.reduce((list, site) => {
        let siteDevices = site.siteDevices.filter(siteDevice => siteDevice.siteDeviceFactors.length > 0)

        if (siteDevices.length > 0) {
          list.push({
            id: site.id,
            name: site.name,
            siteDevices
          })
        }

        return list
      }, [])
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    canNotSearch () {
      let {query} = this
      return query.siteIds.length === 0
    }
  },
  methods: {
    onSitesChanged () {
      let {filterSites, query: {siteIds}} = this

      if (filterSites.length > 0) {
        if (siteIds.length === 0) {
          siteIds.push(filterSites[0].id)
        }

        setTimeout(() => {
          this.getData()
        }, 0)
      }
    },
    getData () {
      let currentQuery = this.currentQuery = JSON.parse(JSON.stringify(this.query))
      this.changeLoadStatus(true)
      this.$api.Data.getAQIGradeNumber({
        ...currentQuery,
        isMultipleIntegral: null,
        granularity: 24
      }).then(dataList => {
        // this.completeData(dataList)
        this.getVOCsCategoryGrade({
          year: new Date(currentQuery.beginTime).getFullYear(),
          isAuditCompleted: currentQuery.isAuditCompleted,
          isMultipleIntegral: currentQuery.isMultipleIntegral,
          grade: 2
        })
        this.$refs.chart.render(dataList)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getVOCsCategoryGrade (param) {
      let {currentQuery} = this
      let {year, grade} = param
      let beginTime = new Date(currentQuery.beginTime)
      let endTime = new Date(currentQuery.endTime)

      beginTime.setFullYear(year)
      endTime.setFullYear(year)

      this.changeLoadStatus(true)
      this.$api.Data.getVOCsCategoryByGrade({
        beginTime: beginTime.format('YYYY/MM/DD HH:mm:ss'),
        endTime: endTime.format('YYYY/MM/DD HH:mm:ss'),
        siteIds: currentQuery.siteIds,
        isAuditCompleted: param.isAuditCompleted,
        isMultipleIntegral: param.isMultipleIntegral,
        unit: this.unit,
        // isAuditCompleted: currentQuery.isAuditCompleted,
        grade
      }).then(this.formatVOCsData).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatVOCsData (dataList) {
      let {filterSiteMap, factorGroupMap} = this
      let dataMap = this.currentQuery.siteIds.reduce((map, siteId) => {
        map[siteId] = {
          siteId: siteId,
          siteName: filterSiteMap[siteId].name,
          count: 0,
          data: []
        }

        return map
      }, {})

      dataList.reduce((map, data) => {
        let {siteId} = data
        let siteDataMap = map[siteId]

        if (!siteDataMap) {
          return map
        }

        let value = data.value

        siteDataMap.data.push({
          name: factorGroupMap[data.groupId].name,
          value,
          isHaveIntegral: data.isHaveIntegral ? data.isHaveIntegral : false
        })

        if (Number.isFinite(value)) {
          siteDataMap.count += value
        }

        return map
      }, dataMap)

      dataList = Object.values(dataMap)
      let maxValue = Math.max(...dataList.map(data => data.count))

      dataList.forEach(data => {
        data.maxValue = maxValue
      })

      this.dataList = Object.freeze(dataList)
      this.renderPieChart()
    },
    renderPieChart () {
      setTimeout(() => {
        this.$refs['pie-charts'].forEach(chart => {
          chart.render()
        })
      }, 0)
    },
    onBeginTimeChanged () {
      this.setDate(0, 'YYYY/12/31 23:59:59')
    },
    onEndTimeChanged () {
      this.setDate(1, 'YYYY/01/01 00:00:00')
    },
    setDate (index, format) {
      let {query} = this
      let dataTimes = [new Date(query.beginTime), new Date(query.endTime)]
      let nextIndex = index ^ 1
      let currentDate = dataTimes[index]
      let nextDate = dataTimes[nextIndex]
      let nowYear = currentDate.getFullYear()

      if (nowYear !== nextDate.getFullYear()) {
        nextDate.setFullYear(nowYear)
        dataTimes[nextIndex] = nextDate.format(format)
        dataTimes[index] = currentDate.format('YYYY/MM/DD HH:mm:ss')
        query.beginTime = dataTimes[0]
        query.endTime = dataTimes[1]
      }
    },
    onYearsChanged (years) {
      this.query.years = JSON.parse(JSON.stringify(years))
    },
    onSearchBtnClick () {
      this.getData()
    },
    onAuditCompletedChanged () {
      this.getData()
    },
    onGradeChartClick (param) {
      this.getVOCsCategoryGrade(param)
    }
  }
}
</script>

<style lang="scss" scoped>
.site-selector {
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/07VOCs-AQI/index.vue